export const defenseStorm = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 25,
  inputPaddingInline: 9,

  inputHeight: 35,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 16,
  inputFontFamily: '"Lato", sans-serif',
  inputColor: "#9B9B93",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#9B9B93",
  inputBorderWidth: 1,
  inputBorderRadius: 3,

  inputHoverColor: "#9B9B93",
  inputHoverBorderColor: "#9B9B93",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 25,
  selectPaddingInline: 9,

  selectHeight: 35,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 16,
  selectFontFamily: '"Lato", sans-serif',
  selectColor: "#9B9B93",
  selectBackgroundColor: "#ffffff",
  selectFontWeight: 400,

  selectBorderColor: "#9B9B93",
  selectBorderWidth: 1,
  selectBorderRadius: 3,

  selectHoverColor: "#9B9B93",
  selectHoverBorderColor: "#9B9B93",
  selectHoverBackgroundColor: "#ffffff",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 35,
  textAreaPaddingInline: 9,

  textAreaHeight: 35,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 16,
  textAreaFontFamily: '"Lato", sans-serif',
  textAreaColor: "#9B9B93",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#9B9B93",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 3,

  textAreaHoverColor: "#9B9B93",
  textAreaHoverBorderColor: "#9B9B93",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#9B9B93",
  placeholderFontFamily: '"Lato", sans-serif',
  placeholderFontSize: 16,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#9B9B93",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 5,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 16,
  fieldLabelColor: "#9B9B93",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#9B9B93",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Lato", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#9B9B93",
  descriptionFontSize: 16,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Lato", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 15,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 3,
  checkboxUncheckedBorderColor: "#9B9B93",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#468C41",
  checkboxCheckedBorderColor: "#9B9B93",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Lato", sans-serif',
  checkboxLabelFontSize: 16,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#9B9B93",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 15,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#9B9B93",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#468C41",
  radioCheckedBorderColor: "#9B9B93",

  radioAlignment: "none",

  radioLabelFontFamily: '"Lato", sans-serif',
  radioLabelFontSize: 16,
  radioLabelFontWeight: 400,
  radioLabelColor: "#9B9B93",

  // **********************************
  // submit button

  submitMarginTop: 25,
  submitFontSize: 18,
  submitFontFamily: "'Lato', sans-serif",
  submitWidth: 113,
  submitWidthUnits: "px",
  submitHeight: 41,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#468C41",
  submitColor: "#ffffff",
  submitBorderColor: "#468C41",
  submitBackgroundHover: "#468C41",
  submitBorderColorHover: "#468C41",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 700,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  